import CommonEdit from "@/components/common/Edit";
import InventoryForm from "../forms/InventoryForm";
import { FC, useEffect, useState } from "react";
import { inventoryForm } from "@/utils/objects";
import { singleProp } from "@/interface/dataInterface";
import axios from "axios";
import { BASE_URL } from "@/config";
import { autofillEditForm } from "@/utils/formChange";
import axiosInstance from "@/utils/axiosInstance";

const InventoryEdit: FC<singleProp> = ({ prop }) => {
  const [formProp, setFormProp] = useState(inventoryForm);

  useEffect(() => {
    const unsub = async () => {
      if (prop) {
        try {
            const {data} = await axiosInstance.get(`/auto-service-inventory/${prop}`)
            const {name, sku, category, description, price, quantity, min_stock_level, unit, supplier_id, warranty_months} = data
            setFormProp({name, category, description, price, quantity, min_stock_level, unit, supplier_id, warranty_months, sku})
        } catch (err) {
          console.log(err);
        }
      }
    };

    unsub();
  }, [prop]);

  return (
    <CommonEdit
      title="Edit"
      id={prop}
      resource="auto-service-inventory"
      data={{...formProp, supplier_id: +formProp.supplier_id}}
    >
      <InventoryForm
        mode="edit"
        formProp={formProp}
        setFormProp={setFormProp}
      />
    </CommonEdit>
  );
};

export default InventoryEdit;
